import React from "react";
import { useQuery } from "react-query";
import { getRoom } from "../../services/game.service";
import AutoSizeText from "../../components/AutoSizeText";

type Props = {};

export default function BannerComponent({}: Props) {
  // call useQuery without assigning unused vars (services read token from sessionStorage)
  const { data: roomData } = useQuery(["get-room-data"], async () => {
    // getRoom() reads token from sessionStorage if not provided
    return await getRoom();
  });
  const data = roomData?.settings?.ticketPointsL4 || [
    50_000, 50_000, 50_000, 50_000, 50_000, 50_000, 50_000, 50_000, 50_000,
    50_000,
  ];

  return (
    <div
      className="grid w-full"
      style={{
        position: "relative",
      }}
    >
      <img
        src="/images/banner.png"
        alt="Banner"
        className="w-full"
        style={{
          aspectRatio: "361/230",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 10,
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            position: "relative",
            height: "100%",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
              gap: "2%",
              position: "absolute",
              width: "64%",
              left: "19%",
              bottom: "10%",
            }}
          >
            {data?.map((value: any, index: any) => (
              <div
                key={index}
                className="aspect-square flex flex-col justify-end items-end relative"
              >
                <div
                  style={{
                    position: "relative",
                    height: "50%",
                    display: "flex",
                    fontSize: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    color: "#0846a7",
                    fontWeight: "bold",
                  }}
                >
                  {value.toLocaleString("en-US")}
                  {/* <AutoSizeText>{value.toLocaleString("en-US")}</AutoSizeText> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
